<template>
  <div class="course-layout">
    <slot></slot>
    <float-btn />
  </div>
</template>

<script>
  import FloatBtn from '@/components/CourseLivingFloatBtn';

  export default {
    name: 'CourseLayout',
    components: {
      FloatBtn,
    },
  };
</script>
